//
// This allows the JS side of the app to be aware of the CSS media query breakpoints.
//
// created November 2014 by Key10

export default {
  mobile: {
    minSize: 0,
    maxSize: 479,
    mediaQuery: '(max-width: 479px)'
  },
  smallTablet: {
    minSize: 480,
    maxSize: 768,
    mediaQuery: '(min-width: 480px) and (max-width: 768px)'
  },
  /* Note: In default bootstrap smallTablet-maxSize is 767 and largeTablet-minSize is 768.
    We override these values so iPad in vertical orientation displays in smallTablet mode
    */
  largeTablet: {
    minSize: 769,
    maxSize: 1199,
    mediaQuery: '(min-width: 769px) and (max-width: 1199px)'
  },
  desktop: {
    minSize: 1200,
    maxSize: 9999,
    mediaQuery: '(min-width: 1200px)'
  }
};
